import { useEffect, useRef, useState } from "react";
import { useInView, motion } from "framer-motion";

function Counter({ end, suffix = "", duration = 1600 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      // easeOutExpo
      const eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      setV(Math.round(end * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, duration]);
  return <span ref={ref}>{v}{suffix}</span>;
}

const STATS = [
  { k: "Festpreis-Angebot", v: 48, s: " h", note: "innerhalb 48 Stunden" },
  { k: "Ø Anfragen-Steigerung", v: 3, s: "×", note: "durch integriertes System" },
  { k: "Zufriedene Kunden", v: 120, s: "+", note: "seit 2026" },
  { k: "Made in", v: 100, s: "%", note: "Bern, Schweiz" },
];

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px" });
  return (
    <section ref={ref} className="bg-[#FAFAF7] border-t border-black/5">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.k}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`relative px-4 md:px-6 ${i > 0 ? "md:border-l md:border-black/10" : ""}`}
            >
              <div className="font-mono-eyebrow text-[#C9A961] mb-3">{String(i + 1).padStart(2, "0")}</div>
              <div className="font-serif-editorial text-5xl md:text-6xl leading-none tracking-tight">
                <Counter end={s.v} suffix={s.s} />
              </div>
              <div className="mt-3 text-xs uppercase tracking-[0.18em] text-[#0A0A0A]/60">{s.k}</div>
              <div className="mt-1 text-sm text-[#0A0A0A]/50">{s.note}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
